// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn___Ac9G","footer":"ChangeClinic_footer__3pyP3"};